export default __webpack_public_path__ + "static/media/ge.5bd56f97.svg";